export enum FloatingInspectorButtonType {
  FloatingInspectorButtonIcon = 'FloatingInspectorButtonIcon',
  FloatingInspectorButtonText = 'FloatingInspectorButtonText',
  FloatingInspectorButtonIconAndText = 'FloatingInspectorButtonIconAndText',
  FloatingInspectorButtonTextFixedWidth = 'FloatingInspectorButtonTextFixedWidth',
  FloatingInspectorButtonTextTwoSections = 'FloatingInspectorButtonTextTwoSections',
  FloatingInspectorButtonImageInCircle = 'FloatingInspectorButtonImageInCircle',
  FloatingInspectorButtonImageInCircleAndText = 'FloatingInspectorButtonImageInCircleAndText',
}

export const FloatingInspectorButtonWidth = {
  FixedTextOnly: 160,
  FixedTextTwoSections: 180,
} as const

export type WidthType = keyof typeof FloatingInspectorButtonWidth;

export enum FloatingInspectorButtonActionType {
  ChangeBackground = 'ChangeBackground',
  Resize = 'Resize',
  RemoveBg = 'RemoveBg',
  RemoveObject = 'RemoveObject',
  ChooseStyle = 'ChooseStyle',
  MagicBg = 'MagicBg',
  FontFamily = 'FontFamily',
  Size = 'Size',
  Eraser = 'Eraser',
  Opacity = 'Opacity',
  Color = 'Color',
  Align = 'Align',
  Spacing = 'Spacing',
  Crop = 'Crop',
  Outline = 'Outline',
  Shadow = 'Shadow',
  Adjust = 'Adjust',
  Filter = 'Filter',
  Group = 'Group',
  Ungroup = 'Ungroup',
  Separator = 'Separator',
}

export type FloatingInspectorButtonAction = `${FloatingInspectorButtonActionType}`;

export type ButtonAction = {
  key: string
  render: () => React.ReactNode
}

export type CollapseConfig = {
  rightOverflowCount: number
  disabled?: boolean
}

export interface CommonBtnProps {
  onClick: () => void
  selected?: boolean
  initialValue?: any
  onValueChange?: (value: any, isFinal?: boolean) => void
  disabled?: boolean
  hasPremium?: boolean
  disableHover?: boolean
  showText?: boolean
}

export interface ResponsiveProps {
  showText?: boolean;
  rightOverflowCount: number;
  setCollapsibleButtonCount: (count: number) => void;
  floatingInspectorContainerRef: React.RefObject<HTMLDivElement>;
}
